import {
  NOTIFICATIONS_TEAM_EMAIL_BACK_BTN_PRESSED,
  NOTIFICATION_WIDGET_ADD_TEAM_DISPLAYED,
} from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

export const sendSetTeamEmailBackEvent = () => {
  const eventData = {
    eventName: NOTIFICATIONS_TEAM_EMAIL_BACK_BTN_PRESSED,
  };
  getTrackingAdapter.sendLinkEvent(eventData);
};

export const sendOnProgressPointClick = (
  fromStepIndex: number,
  toStepIndex: number,
) => {
  const eventData = {
    eventName: `notifications_nav_from_step_${fromStepIndex}_to_${toStepIndex}_pressed`,
  };
  getTrackingAdapter.sendLinkEvent(eventData);
};

export const sendNotificationsImpressionEvents = (
  impressionName: string,
  addTeamMember?: boolean,
) => {
  const eventData = {
    eventName: impressionName,
  };
  getTrackingAdapter.sendLinkEvent(eventData);

  if (addTeamMember) {
    getTrackingAdapter.sendLinkEvent({
      eventName: NOTIFICATION_WIDGET_ADD_TEAM_DISPLAYED,
    });
  }
};
